<template>
  <small>redirecting</small>
</template>

<script charset="utf-8">
  

import router from '@/router';
import url from '@/services/urlService';

export default {
  mounted() {
    this.$store.commit('RESET_STATE');
    url.rawRedirect('login');
  }
}

</script>
